export default __webpack_public_path__ + "static/media/money.ce7fe0e8.svg";